import { render, staticRenderFns } from "./CheckItem.vue?vue&type=template&id=095af817&scoped=true&"
import script from "./CheckItem.vue?vue&type=script&lang=js&"
export * from "./CheckItem.vue?vue&type=script&lang=js&"
import style0 from "./CheckItem.vue?vue&type=style&index=0&id=095af817&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "095af817",
  null
  
)

export default component.exports